// extracted by mini-css-extract-plugin
export default {"styles":"styles___ZURBm","Link":"Link___Ng9g8","activated":"activated___W7pXq","discoverTabs":"discoverTabs___w4JpW"};